import { service } from '@ember/service';
import Component from '@glimmer/component';
import { parseISO, formatRelative } from 'date-fns';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type FlashMessagesService from 'garaje/services/flash-messages';
import type { AtlasDisplay } from 'garaje/utils/atlas';

interface AtlasTableRowComponentProps {
  display: AtlasDisplay;
}

export default class AtlasTableRowComponent extends Component<AtlasTableRowComponentProps> {
  @service declare flashMessages: FlashMessagesService;
  @service declare ajax: AjaxFetchService;

  get status(): 'offline' | 'online' {
    const lastHeartbeatAt = this.args.display.lastHeartbeatAt as unknown as string;
    const now = Date.now() / 1000;
    const lastHeartbeatSeconds = parseISO(lastHeartbeatAt || '').getTime() / 1000;
    const difference = Math.abs(now - lastHeartbeatSeconds);
    const offlineThresholdSeconds = 60 * 5;

    if (!lastHeartbeatAt || difference > offlineThresholdSeconds) {
      return 'offline';
    }

    return 'online';
  }

  get lastOnline(): string {
    const lastHeartbeatAt = this.args.display.lastHeartbeatAt as unknown as string;

    if (!lastHeartbeatAt) {
      return 'never';
    }

    const lastHeartbeatDate = parseISO(lastHeartbeatAt);

    return formatRelative(lastHeartbeatDate, Date.now());
  }

  get pairedDate(): string {
    const createdAt = this.args.display.createdAt;

    if (!createdAt) {
      return 'never';
    }

    const pairedDate = parseISO(createdAt);

    return formatRelative(pairedDate, Date.now());
  }
}
